import { useState, useEffect } from "react";
import { useGetDeviceManualQuotaLogsforReportMutation } from "../../store/storageRoles/devicesSharedApi";
import logger from "../../utils/logger";

export const useDeviceManualQuotaReportData = (deviceId, token) => {
  const [input, setInput] = useState({
    type: "UpdateManualQuota",
  });
  const [date, setDate] = useState(null);
  const [dateSecond, setDateSecond] = useState(null);
  const [Datas, setDatas] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [info, setInfo] = useState(null);

  const [getDeviceManualQuotaLogsforReport, { data, isLoading, error }] =
    useGetDeviceManualQuotaLogsforReportMutation();

  const handleGetLogData = async (productName = null) => {
    if (!deviceId || !token || !date || !dateSecond) {
      return;
    }

    try {
      // Önceki verileri temizle
      setDatas([]);

      const requestData = {
        id: deviceId,
        createdInfo: date,
        createdInfoSecond: dateSecond,
        token: token,
      };

      const result = await getDeviceManualQuotaLogsforReport(
        requestData
      ).unwrap();

      if (result && result.data) {
        setDatas(result.data);
      }
    } catch (error) {
      logger.error("❌ Manual Quota Report Error:", error);
    }
  };

  // Data değiştiğinde Datas'ı güncelle
  useEffect(() => {
    if (data && data.data) {
      setDatas(data.data);
    }
  }, [data]);

  return {
    input,
    setInput,
    date,
    setDate,
    dateSecond,
    setDateSecond,
    Datas,
    selectedDate,
    setSelectedDate,
    info,
    setInfo,
    isLoading,
    error,
    handleGetLogData,
  };
};
